import React, { useEffect, useState } from "react";

import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import getCacheBustingQuery from "../../Util/getCacheBustingQuery";

import * as constant from "../../global/const";
import { useSelector } from "react-redux";

//imagenes
import noimage from "../../assets/images/postobon.png";
import lefth from "../../assets/icons/left.svg";
import rigth from "../../assets/icons/rigth.svg";

//axios
import axios from "axios";

const BannerComponent = () => {
  const [bannerPrincipal, setBannerPrincipal] = useState([]);
  const [bannerSecundario, setBannerSecundario] = useState([]);
  //const sucursal = useSelector(state => state.page.sucursal);
  // const sucursal = JSON.parse(localStorage.getItem('sucursal'));
  const sucursal = useSelector((state) => state.page.sucursal);

  const onClickItem = (item) => {
    window.location.href = bannerPrincipal[item].link;
  };

  const getBannerPrimario = () => {
    axios
      .get(
        constant.GETBANNER +
          "?tipo=1&nit=" +
          sucursal.nit +
          "&codigo=" +
          sucursal.codigo +
          "&agencia=" +
          sucursal.agencia
      )
      .then((response) => {
        setBannerPrincipal(response.data);
      })
      .catch((err) => {});
  };

  const getBannerSecundario = () => {
    axios
      .get(
        constant.GETBANNER +
          "?tipo=2&nit=" +
          sucursal.nit +
          "&codigo=" +
          sucursal.codigo +
          "&agencia=" +
          sucursal.agencia
      )
      .then((response) => {
        setBannerSecundario(response.data);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    if (sucursal) {
      getBannerPrimario();
      getBannerSecundario();
    }
  }, [sucursal]);

  return (
    <React.Fragment>
      <div className="carouseles">
        <div
          id="carouselExampleIndicators-1"
          className="carousel slide carousel-1"
          data-ride="carousel"
        >
          <div className="carousel-inner">
            {bannerPrincipal.length !== 0 ? (
              bannerPrincipal.map((slide, i) => (
                <>
                  {i === 0 ? (
                    <a
                      href={slide.link}
                      target="_blank"
                      className="carousel-item active"
                      key={i}
                    >
                      <img
                        className="d-block w-100"
                        src={
                          `${constant.URL_BASE_IMAGES}` +
                          (window.screen.width < 600 ? "Movil" : "Web") +
                          `/BannerPrimario/${
                            slide.id
                          }.jpg?${getCacheBustingQuery(1)}`
                        }
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src =
                            "https://mir-s3-cdn-cf.behance.net/project_modules/fs/d6d76a80595813.5ce599d691897.png";
                        }}
                        alt="First slide"
                      />
                    </a>
                  ) : (
                    <a
                      href={slide.link}
                      target="_blank"
                      className="carousel-item"
                      key={i}
                    >
                      <img
                        className="d-block w-100"
                        src={
                          `${constant.URL_BASE_IMAGES}` +
                          (window.screen.width < 600 ? "Movil" : "Web") +
                          `/BannerPrimario/${
                            slide.id
                          }.jpg?${getCacheBustingQuery(1)}`
                        }
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src =
                            "https://mir-s3-cdn-cf.behance.net/project_modules/fs/d6d76a80595813s.5ce599d691897.png";
                        }}
                        alt="First slide"
                      />
                    </a>
                  )}
                </>
              ))
            ) : (
              <div className="notFound">&nbsp;</div>
            )}
          </div>

          <div className="carrousel-controls">
            <a
              className="carousel-control-prev"
              href="#carouselExampleIndicators-1"
              role="button"
              data-slide="prev"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Previous</span>
            </a>
            <ol className="carousel-indicators">
              {bannerPrincipal.length !== 0 ? (
                bannerPrincipal.map((slide, i) => (
                  <>
                    {i === 0 ? (
                      <li
                        data-target="#carouselExampleIndicators-1"
                        className="active"
                        key={i}
                        data-slide-to={i.toString()}
                      >
                        {i + 1}
                      </li>
                    ) : (
                      <li
                        data-target="#carouselExampleIndicators-1"
                        key={i}
                        data-slide-to={i.toString()}
                      >
                        {i + 1}
                      </li>
                    )}
                  </>
                ))
              ) : (
                <>&nbsp;</>
              )}
            </ol>
            <a
              className="carousel-control-next"
              href="#carouselExampleIndicators-1"
              role="button"
              data-slide="next"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Next</span>
            </a>
          </div>
        </div>

        <div
          id="carouselExampleIndicators-2"
          className="carousel slide carousel-2"
          data-ride="carousel"
        >
          <div className="carousel-inner">
            {bannerSecundario.length !== 0 ? (
              bannerSecundario.map((slide, i) => (
                <>
                  {i === 0 ? (
                    <a
                      href={slide.link}
                      target="_blank"
                      className="carousel-item active"
                      key={i}
                    >
                      <img
                        className="d-block w-100"
                        src={
                          `${constant.URL_BASE_IMAGES}` +
                          (window.screen.width < 600 ? "Movil" : "Web") +
                          `/BannerSecundario/${
                            slide.id
                          }.jpg?${getCacheBustingQuery(1)}`
                        }
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src =
                            "https://mir-s3-cdn-cf.behance.net/project_modules/fs/d6d76a80595813.5ce599d691897.png";
                        }}
                        alt="First slide"
                      />
                    </a>
                  ) : (
                    <a
                      href={slide.link}
                      target="_blank"
                      className="carousel-item"
                      key={i}
                    >
                      <img
                        className="d-block w-100"
                        src={
                          `${constant.URL_BASE_IMAGES}` +
                          (window.screen.width < 600 ? "Movil" : "Web") +
                          `/BannerSecundario/${
                            slide.id
                          }.jpg?${getCacheBustingQuery(1)}`
                        }
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src =
                            "https://mir-s3-cdn-cf.behance.net/project_modules/fs/d6d76a80595813.5ce599d691897.png";
                        }}
                        alt="First slide"
                      />
                    </a>
                  )}
                </>
              ))
            ) : (
              <div className="notFound">&nbsp;</div>
            )}
          </div>

          <div className="carrousel-controls">
            <a
              className="carousel-control-prev"
              href="#carouselExampleIndicators-2"
              role="button"
              data-slide="prev"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Previous</span>
            </a>
            <ol className="carousel-indicators">
              {bannerSecundario.length !== 0 ? (
                bannerSecundario.map((slide, i) => (
                  <>
                    {i === 0 ? (
                      <li
                        data-target="#carouselExampleIndicators-2"
                        key={i}
                        className="active"
                        data-slide-to={i.toString()}
                      >
                        {i + 1}
                      </li>
                    ) : (
                      <li
                        data-target="#carouselExampleIndicators-2"
                        key={i}
                        data-slide-to={i.toString()}
                      >
                        {i + 1}
                      </li>
                    )}
                  </>
                ))
              ) : (
                <></>
              )}
            </ol>
            <a
              className="carousel-control-next"
              href="#carouselExampleIndicators-2"
              role="button"
              data-slide="next"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Next</span>
            </a>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BannerComponent;
